import styled from 'styled-components'
import config from '../../config'

interface OnDemandStyleProps {
  mobileHeight: number
}

export const OnDemandStyle = styled.div<OnDemandStyleProps>`
  background-image: url('${config.assets.gallerium}');
  background-size: cover;
  height: ${(props) => props.mobileHeight}px;
  overflow: hidden;

  // layout -> content -> grid-container OR infinite-scroll-container
  .page-layout {
    backdrop-filter: blur(15px);
    background-color: rgba(255, 255, 255, 0.2);
  }

  .page-content {
    .grid-container {
      display: grid;
      grid-gap: 20px;
      grid-template-columns: repeat(auto-fit, 45%);
      grid-auto-rows: max-content;
      justify-content: center;
      text-align: center;
      position: relative;
      overflow-y: scroll;
      height: ${(props) => props.mobileHeight - 120}px;

      .card-thumbnail {
        display: block;
        cursor: pointer;
        position: relative;
        text-align: center;
        color: white;
        font-weight: 600;
        text-decoration: none;
        font-size: 16px;
      }
    }
  }

  // header
  .back-btn {
    height: 60px;
    padding: 0 20px;
    background: #394554;
    font-weight: bold;
    color: #f85d49;
    background: transparent;
    border: none;
    display: flex;
    align-items: center;
    text-decoration: none;
    .back-icon {
      display: flex;
      width: 30px;
      flex-direction: column;
      img,
      svg {
        transition: 100ms linear;
        height: 24px;
      }
      .icon-label {
        text-align: left;
        font-size: 1px;
        opacity: 0;
      }
    }
    span {
      font-size: 18px;
      font-style: italic;
      margin-left: 1em;
      color: #f85d49;
    }
  }
`
